import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
export function lazyLoad(view) {
  return function () {
    return import("@/views/clientes/".concat(view, ".vue"));
  };
}
export default [{
  path: "consulta",
  component: lazyLoad('Consulta'),
  name: "Consulta",
  title: "Consulta Solicitud",
  hidden: true,
  props: true,
  meta: {
    title: 'Consulta solicitud',
    hidden: true
  }
}, {
  path: "detalle",
  component: lazyLoad('viewCliente'),
  name: "viewCliente",
  title: "Data Solicitud",
  hidden: true,
  props: true,
  meta: {
    title: 'Solicitud',
    hidden: true
  }
}];